import React from 'react'
import "./Tab_holder.css"
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Nav } from 'react-bootstrap'

function Tab_holder() {
    return (
        <>
            <section className='Account_Tab_holder'>
                <div className="top_heading_holder">
                    <div className='profile_name_holder'>
                        <div>
                            <div className="profile_holder">
                                <p>SL</p>
                            </div>
                        </div>

                        <div className="name_holder">
                            <h4>HELLO, </h4>
                            <p>Smita L</p>
                        </div>
                    </div>

                    <div>
                        <div className="edit_holder">
                            <FontAwesomeIcon className='edit_icon' icon={faPenToSquare} />
                        </div>
                    </div>

                </div>

                <div className="tab_list_holder">
                    <Nav variant="pills" className="flex-column tab_list">
                        <Nav.Item>
                            <Nav.Link eventKey="Personal_Details">Personal Details</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="Driving_School_Details">Driving School Details</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="Subscription_Plan">Subscription Plan</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
            </section>
        </>
    )
}

export default Tab_holder